import { MapPinPlus } from '@lucide/vue';
import type { CommandFactory } from './commands';
import { appLocationCommand } from './appCommand';

/**
 * Sites' app-wide palette entry (I-2348): a new site, created by the site
 * dashboard for `?new=site` once its sites are loaded. A site view's ⋯ menu
 * joins the palette while the view is open (frontend/sites).
 */
export const sitesCommands: CommandFactory = ({ router, t, appLabel: sites }) => [
  appLocationCommand(router, {
    id: 'sites.newSite',
    app: 'sites',
    group: sites,
    label: `${sites}: ${t('sites.site.createTitle')}`,
    href: '/sites?new=site',
    icon: MapPinPlus,
    keywords: ['sites', 'standort', 'site', 'gebäude', 'neu', 'new', 'anlegen'],
  }),
];
